@if (premiumModal.isVisible()) {
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="premiumModalLabel" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
      <div class="modal-content border-0 shadow">
        <div class="modal-body text-center py-4 px-4">
          <div class="rounded-circle bg-primary bg-opacity-10 text-primary d-inline-flex align-items-center justify-content-center mb-3 premium-circle" style="width: 56px; height: 56px;">
            <i class="bi bi-star-fill premium-star-icon"></i>
          </div>
          <h5 class="modal-title mb-2" id="premiumModalLabel">Premium feature</h5>
          <p class="text-muted small mb-0">{{ premiumModal.currentMessage() }}</p>
        </div>
        <div class="modal-footer border-0 justify-content-center pb-4 pt-0">
          <button type="button" class="btn btn-premium btn-sm px-3" (click)="premiumModal.close()">Got it</button>
        </div>
      </div>
    </div>
  </div>
}
